import React from 'react';

import {type RouteData} from '../types';
import {CREATE_SWEEP_PATH, SWEEP_PATHS} from './sweepWorkspacePaths';

export const SWEEP_ROUTES_DATA: RouteData[] = [
  {
    additionalProps: {
      allowIframes: true,
      datadogViewName: 'CreateSweep',
    },
    exact: true,
    isPrivateRoute: true,
    path: CREATE_SWEEP_PATH,
    RouteComponent: React.lazy(() => import('../../pages/CreateSweepPage')),
  },
  {
    additionalProps: {
      allowIframes: true,
      datadogViewName: 'Sweep',
    },
    exact: true,
    isPrivateRoute: false,
    path: SWEEP_PATHS,
    RouteComponent: React.lazy(() => import('../../pages/SweepPage')),
  },
];
